import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { COURSE_MESSAGES } from "../messages";
import type { SyllabusItem } from "../types";

interface CourseSyllabusProps {
    items?: SyllabusItem[];
    showIcons?: boolean; // Check icon before each item (used on the purchase page)
}

// The API may send plain strings or objects, so both are normalized to text
const getItemText = (item: SyllabusItem): string =>
    typeof item === "string" ? item : item.title || item.name || "";

const CourseSyllabus = ({ items, showIcons = false }: CourseSyllabusProps) => {
    if (!Array.isArray(items) || items.length === 0) {
        return <p className="text-gray-500">{COURSE_MESSAGES.noSyllabus}</p>;
    }

    return (
        <ul className="flex flex-col text-lg w-full gap-3">
            {items.map((item, index) => (
                <li
                    key={index}
                    className={classNames(
                        "border-b border-gray-200 pb-3",
                        showIcons && "flex items-center gap-3"
                    )}
                >
                    {showIcons && (
                        <FontAwesomeIcon icon={faCircleCheck} className="text-gray-500" />
                    )}
                    <span>{getItemText(item)}</span>
                </li>
            ))}
        </ul>
    );
};

export default CourseSyllabus;